import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/en/industries/medical-devices/medical-device-software")({
  head: () => buildRouteHead("/en/industries/medical-devices/medical-device-software"),
  component: SolutionDetail,
});

